export default {
  title: 'Activities',
};
